import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1c454e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "search"
}
const _hoisted_2 = { class: "viewport flex-center guideDom-pure-all-2" }
const _hoisted_3 = { class: "rel search-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "abs",
  style: {"left":"78px","top":"1px","color":"var(--el-input-text-color, var(--el-text-color-regular))"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-caret-down" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref, computed, reactive, onMounted, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useRtfix, useSite2Station } from '@/store'
import ToolBar from '@/components/bussiness/ToolBar.vue'
import HotSearch from './HotSearch.vue'
import { isUrl } from '@/plugins/utils'
import { getTranslationText } from '@/apis/common'
import gbk from 'gbk-encode'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { bury } from '@/util/useBury'
import { uploadAliOSS, GOODS_IMAGE_SEARCH } from '@/util/useUpload'
import { searchByImage } from '@/util/useSearchByImage'
import { ElMessage } from 'element-plus'
import { Site } from '@/common/const'
import { SearchLangType } from '@/common/search'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/**
 * <el-option size="small" :label="t('日本语入力')" :value="1" />
 * <el-option size="small" :label="t('中国语入力')" :value="2" />
 */
const { encode } = gbk

const mutate = ref(1)
const site = useSite2Station()
const langTypeOtions = [
  {
    value: {
      [Site.JA]: SearchLangType.JA, // 日语
      [Site.KO]: SearchLangType.KR, // 韩语
      [Site.EN]: SearchLangType.EN // 英语
    }[site],
    label: {
      [Site.JA]: '日本语入力',
      [Site.KO]: '한국어 입력',
      [Site.EN]: 'English'
    }[site]
  },
  {
    value: SearchLangType.ZH,
    label: t('请输入中文')
  }
]

const router = useRouter()
const route = useRoute()
const store = useStore()

const buss = reactive(store.state.bussiness)
const langType = computed(() => buss.langType)
console.log(route, 'route')
const keyword = ref('')
watch(() => route.query.keyword, (val) => {
  val && (keyword.value = String(val))
}, { immediate: true })
const showHot = ref(0)
const searchRef = ref()
const nullTrigger = ref(false)

onMounted(() => {
  store.commit('bussiness/langType', langTypeOtions[0].value)
})
watch(langType, (val) => {
  localStorage.setItem('SearchLangType', val)
})
// let isEnter = false
const handleEnter = () => {
  // isEnter = !isEnter
  // if (isEnter) {
  //   setTimeout(() => {
  //     isEnter && handleSearch()
  //     isEnter = false
  //   }, 400)
  // }
}

const handleSearch = () => {
  const kw = keyword.value.trim()
  searchRef.value.blur()
  if (kw) {
    const query: any = {}
    query.langType = langType.value
    query.keyword = kw
    query._t = Date.now()
    // reset()
    console.log(route.path?.toString().includes('brand/list') ? 'replace' : 'push')
    router[route.path?.toString().includes('brand/list') ? 'replace' : 'push'](
      useRtfix('BrandList', { query })
    )
  } else {
    nullTrigger.value = true
    setTimeout(() => {
      searchRef.value.focus()
      nullTrigger.value = false
    }, 1500)
  }
}

const reset = (clear: boolean | void) => {
  if (clear) {
    keyword.value = ''
  }
}
// 搜索历史框选中关键词
const hotSearchSelected = (key: string) => {
  console.log(key)
  keyword.value = key
  console.log(keyword.value)
}

// 图搜
const uploadImageRef = ref()
const choosePic = (e: any) => {
  const file = e.target.files[0]
  // 清空一下这个input的值不然选同一个文件不触发事件
  uploadImageRef.value.value = ''
  searchByImage(file).then(() => {
    reset(true)
  })
}

const setShowHot = () => {
  setTimeout(() => {
    showHot.value = 0
  }, 100)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ToolBar),
    (!_unref(route).path?.toString().includes('brand/detail'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                class: _normalizeClass(["rel", { 'null-trigger': nullTrigger.value }]),
                ref: (_value, _refs) => {
                  _refs['searchRef'] = _value
                  searchRef.value = _value
                },
                placeholder: _unref(t)('请输入主营类目、品牌名称或风格'),
                type: "text",
                maxlength: "500",
                modelValue: keyword.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyword).value = $event)),
                title: keyword.value,
                onFocus: _cache[4] || (_cache[4] = () => {
              showHot.value = 1;
            }
            ),
                onBlur: setShowHot,
                onKeyup: _withKeys(handleEnter, ["enter"])
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    defaultValue: _unref(langType),
                    "model-value": _unref(langType),
                    size: "small",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)('ALL_Click_LanguageChose'))),
                    style: {"width":"100px"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(store).commit('bussiness/langType', $event)))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langTypeOtions, (lang) => {
                        return _createVNode(_component_el_option, {
                          size: "sime",
                          key: lang.value,
                          label: lang.label,
                          value: lang.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["defaultValue", "model-value"]),
                  _hoisted_4
                ]),
                suffix: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("div", {
                    style: {"height":"34px"},
                    class: "flex-ter rel pl_10 searchIcon",
                    onClick: _cache[2] || (_cache[2] = () => { handleSearch() })
                  }, [
                    _createVNode(SvgIcon, {
                      style: {"font-size":"18px","color":"#fff","margin-left":"5px"},
                      class: "btn rel",
                      name: "搜索"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["class", "placeholder", "modelValue", "title", "onKeyup"]),
              _createVNode(_Transition, {
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut"
              }, {
                default: _withCtx(() => [
                  (showHot.value)
                    ? (_openBlock(), _createBlock(HotSearch, {
                        key: 0,
                        modelValue: keyword.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((keyword).value = $event)),
                        onSelected: hotSearchSelected,
                        onHandleSearch: handleSearch
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})